import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[disableAutocomplete]'
})
export class DisableAutocompleteDirective {

  constructor(private el: ElementRef) {}

  @HostListener('focus')
  disableAutocomplete() {
    const randomValue = 'off' + Math.random().toString();
    this.el.nativeElement.setAttribute('autocomplete', randomValue);
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/disable-autocomplete/disable-autocomplete.directive.ts